import { Box, Typography } from '@mui/material';
import { UnavailableIndicator } from './UnavailableIndicator';

type ConfidenceIndicatorProps = {
  // 0-1 fraction.
  value: number | null;
};

export const ConfidenceIndicator = ({ value }: ConfidenceIndicatorProps) => (
  <Box sx={{ minWidth: 140 }}>
    <Typography variant="caption" color="text.secondary" display="block">
      OCR confidence
    </Typography>
    {value == null ? (
      <UnavailableIndicator />
    ) : (
      <Typography variant="h6">{Math.round(value * 100)}%</Typography>
    )}
  </Box>
);
